import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/functions'
import 'firebase/storage'
import { GeoFirestore } from 'geofirestore'

const config = {
  apiKey: 'AIzaSyApyobv7BQmk5mISfK3BO2TREbXkY_Uvek',
  authDomain: 'psyservice-prod.firebaseapp.com',
  databaseURL: 'https://psyservice-prod.firebaseio.com',
  projectId: 'psyservice-prod',
  storageBucket: 'psyservice-prod.appspot.com',
  messagingSenderId: '502244787136',
  appId: '1:502244787136:web:8c4e9e18307b629121be25',
  measurementId: 'G-4G80RK5J3R'
}

firebase.initializeApp(config)

// eslint-disable-next-line no-unused-vars
const DEBUG = process.env.NODE_ENV === 'development'

// firebase utils
export const firestore = firebase.firestore()
export const auth = firebase.auth()
export const storage = firebase.storage()
export const functions = firebase.functions()
export const currentUser = auth.currentUser

DEBUG && functions.useFunctionsEmulator('http://localhost:5001')

// firebase collections
export const usersCollection = firestore.collection('users')
export const postsCollection = firestore.collection('posts')
export const plansCollection = firestore.collection('plans')
export const specialtiesCollection = firestore.collection('specialties')
export const premiumUsersCollection = firestore.collection('premiumUsers')
export const adminUsersCollection = firestore.collection('adminUsers')
export const favoritesCollection = firestore.collection('favorites')
// Create a GeoFirestore reference
export const geofirestore = new GeoFirestore(firestore)

// Create a professionalsGeoCollection reference
export const professionalsGeoCollection = geofirestore.collection('professionals')
